import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20rose%20and%20golden%20gradient%20overlay%2C%20elegant%20flowing%20curves%20reminiscent%20of%20film%20reels%2C%20theater%20curtains%20in%20deep%20red%20tones%2C%20soft%20bokeh%20lights%2C%20luxurious%20and%20artistic%20atmosphere%2C%20minimalist%20composition%20with%20rich%20texture&width=1600&height=900&seq=hero-rose-video-01&orientation=landscape"
        alt="玫瑰视频 - 高清影视在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
          玫瑰视频
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mb-8 leading-relaxed">
          汇集<strong>香蕉视频</strong>、<strong>糖豆视频</strong>、<strong>小蓝视频</strong>、<strong>蓝莓视频</strong>等热门影视资源，高清免费在线观看不缓冲，海量电视剧全集和电影大全每日更新，满足各类追剧需求。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/tv-series"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            开始追剧
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/movies"
            className="px-8 py-3 bg-white/20 hover:bg-white/30 text-white backdrop-blur-sm rounded-full font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-200 border border-white/30"
          >
            观看电影
            <i className="ri-film-line ml-2"></i>
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          {[
            { label: "影视资源", value: "5000+" },
            { label: "高清剧集", value: "10万+" },
            { label: "每日更新", value: "100+" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-accent-400">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}